var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["empty/category-empty-filter.j2"] = require( "empty/category-empty-filter.j2" );
dependencies["empty/category-empty-brands.j2"] = require( "empty/category-empty-brands.j2" );
dependencies["empty/category-empty.j2"] = require( "empty/category-empty.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-browse-heading.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
output += "\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"isEmptyRefinement")) {
env.getTemplate("empty/category-empty-filter.j2", false, "category/templates/category-browse-heading.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
})});
}
else {
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"totalRecordCount") == 0) {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") == "brands") {
env.getTemplate("empty/category-empty-brands.j2", false, "category/templates/category-browse-heading.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
})});
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"context") == "category") {
env.getTemplate("empty/category-empty.j2", false, "category/templates/category-browse-heading.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
})});
}
;
}
;
}
else {
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-browse-heading.j2"] , dependencies)